import { api } from '@/shared/services/api';

/**
 * Client API pentru turul ghidat — multi-tour API.
 * Fiecare tour are un ID (ex. 'overview', 'first-invoice'). State-ul e persistat
 * pe server (cross-device, supraviețuiește refresh-ului).
 *
 * Backward-compat: pentru tourId='overview' API-ul backend menține și câmpurile
 * vechi (uiTourCompletedAt/uiTourSkippedAt) — clientul nu se ocupă de asta.
 */
export const tourApi = {
  markCompleted: (tourId: string) =>
    api.post<{ ok: true }>(`/auth/tour/${encodeURIComponent(tourId)}/complete`),

  markSkipped: (tourId: string) =>
    api.post<{ ok: true }>(`/auth/tour/${encodeURIComponent(tourId)}/skip`),

  restart: (tourId: string) =>
    api.delete<{ ok: true }>(`/auth/tour/${encodeURIComponent(tourId)}`),
};
